<button (click)="emitToggle()" [class.is-disabled]="disabled">
  <i *ngIf="!isChecked" class="is-unchecked far fa-circle" aria-hidden="true"></i>
  <i *ngIf="isChecked"  class="is-checked fa fa-check-circle" aria-hidden="true"></i>
</button>